import React, {Component} from 'react';
import CONSTANTS from '../../config/constants'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClipboardList, faChevronDoubleRight} from '@fortawesome/pro-regular-svg-icons';
import {getPageUrl} from "../../../core/helpers/CoreHelpers";
import _ from "lodash";
import {withRouter} from "react-router";
import moment from 'moment';

class TasksBlock extends Component {
    slickSettings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true
    };

    getContentFieldValue = (fieldDefinitionKey, contents = false) => {
        const {contentFields} = this.props;
        const items = contents ? contents : contentFields;
        const data = _.find(items, {fieldDefinitionKey: fieldDefinitionKey});

        if (data) {
            try {
                return JSON.parse(data.data);
            } catch (e) {
                return data.data;
            }
        }
        return false
    };

    getBlockWidth = () => {
        const {width} = this.props;

        let w = 40;

        if (width && width !== CONSTANTS.BLOCK_DEFAULT_WIDTH) {
            return width;
        } else {
            if (this.getContentFieldValue('Width') && this.getContentFieldValue('Width') !== CONSTANTS.BLOCK_DEFAULT_WIDTH && this.getContentFieldValue('Width') !== w) {
                w = this.getContentFieldValue('Width');
            }
        }

        return w;
    };

    followLink = (e, link) => {
        const {router} = this.props;

        e.preventDefault();
        e.stopPropagation();

        if(link) {
            if(link.target) {
                window.open(getPageUrl(link.contentId), '_blank');
            } else {
                router.push(`/page/${link.contentId}`);
            }
        }
    };

    formatDate = (value) => {
        const noTime = /^\d{4}-\d{2}-\d{2}$/.test(value);

        if (noTime) {
            return value;
        }

        return moment(value).utc().format(noTime ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm');
    };

    render() {
        const {relatedContents} = this.props;

        const data = {
            title: this.getContentFieldValue('Title'),
            tasks: relatedContents.map(item => {
                return {
                    title: this.getContentFieldValue('Title', item.contentFields),
                    task: this.getContentFieldValue('Task', item.contentFields),
                    dueDate: this.getContentFieldValue('Due date', item.contentFields)
                }
            }),
            readMoreLink: this.getContentFieldValue('TasksLink')
        };

        return (
            <section className={"tasks w--" + this.getBlockWidth() + " show--shadow"}>
                <section className="tasks--inner">
                    <h3>
                        <span><FontAwesomeIcon icon={faClipboardList}/></span>
                        <em>{data.title}</em>
                    </h3>
                    <ul>
                        {data.tasks.map((task, key) => (
                            <li key={key}>
                                <em>{task.title}</em>
                                <span>Due date: {this.formatDate(task.dueDate)}</span>
                            </li>
                        ))}
                    </ul>
                    {data.readMoreLink &&
                    <div className="link" onClick={(e) => this.followLink(e, data.readMoreLink)}>
                        {data.readMoreLink.title}
                        {' '}
                        <FontAwesomeIcon icon={faChevronDoubleRight}/>
                    </div>
                    }
                </section>
            </section>
        )
    }
}

export default withRouter(TasksBlock);


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/TasksBlock.js